"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormActions = void 0;
var _FormActions = require("./FormActions");
// TODO: in v9, move styled() from FormActions.jsx to here
var StyledFormActions = _FormActions.FormActions;
exports.StyledFormActions = StyledFormActions;